const DB_NAME = 'material_center_db';
const DB_STORE = 'files';

export function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(DB_STORE)) {
        db.createObjectStore(DB_STORE);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function getFileFromDB(key) {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(DB_STORE, 'readonly');
      const store = tx.objectStore(DB_STORE);
      const request = store.get(key);
      request.onsuccess = () => {
        const fileData = request.result;
        // Return the actual File object if stored with metadata
        resolve(fileData?.file || fileData);
      };
      request.onerror = () => reject(request.error);
    });
  } catch (e) {
    console.warn('Failed to get file from DB:', e);
    return null;
  }
}

export async function getAllFilesFromFolder(folderName) {
  try {
    const db = await openDB();
    return new Promise((resolve, reject) => {
      const tx = db.transaction(DB_STORE, 'readonly');
      const store = tx.objectStore(DB_STORE);
      const request = store.getAll();
      request.onsuccess = () => {
        const allFiles = request.result;
        const folderFiles = allFiles
          .filter(fileData => {
            if (!fileData) return false;
            const path = fileData.webkitRelativePath || fileData.key || '';
            // Match if path contains the folder name
            return path.includes(`/${folderName}/`) ||
                   path.startsWith(`${folderName}/`) ||
                   path.includes(`\\${folderName}\\`) ||
                   path.startsWith(`${folderName}\\`);
          })
          .map(fileData => fileData.file || fileData);
        resolve(folderFiles);
      };
      request.onerror = () => reject(request.error);
    });
  } catch (e) {
    console.warn('Failed to get files from folder:', e);
    return [];
  }
}
